module.exports = __webpack_public_path__ + "img/143.0ed1c70b.jpg";